

import { Vue, Component, Watch, Prop } from 'vue-property-decorator'
import CircleWithInitials from "@/components/card/CircleWithInitials.vue";
import SchedulerItemAvatar from "@/components/scheduler/SchedulerItemAvatar.vue";
import EmployeeHoverCard from './EmployeeHoverCard.vue';
import { hslColorFromName } from "@/utils/hslColorFromName";
import initialsHelper from "@/helpers/cardInfoHelperFunctions/initialsHelper";

@Component({
    components: {
        CircleWithInitials,
        SchedulerItemAvatar,
        EmployeeHoverCard
    },
})
export default class EmployeeItem extends Vue {
    @Prop({ type: Object, default: null }) readonly item!: any;
    @Prop({ type: Boolean, default: null }) readonly isOpened!: boolean;
    @Prop({ type: String, default: null }) readonly filterBy!: string;
    @Prop({ type: Boolean, default: null }) readonly isInner!: boolean;
    @Prop({ type: Boolean, default: null }) readonly isManager!: boolean;
    @Prop({ type: Number, default: 0 }) readonly projectsInprogress!: number;
    @Prop({ type: Number, default: 0 }) readonly projectsCompleted!: number;
    @Prop({ type: Array, default: null }) readonly projects!: number;
    @Prop({ type: Array, default: null }) readonly contractors!: number;
    @Prop({ type: Object, default: null }) readonly manager!: any;
    @Prop({ type: String, default: null }) readonly color!: string;


    isCollapsed: boolean = this.isOpened;
    isShowInfor: boolean = false;
    //create function to collapse and expand
    toggleCollapse() {
        this.isCollapsed = !this.isCollapsed;
        this.$emit('toggleCollapse', this.isCollapsed);
    }

    toggleInfoCard() {
        this.isShowInfor = true;
    }

    toggleInfoCardOff() {
        this.isShowInfor = false;
    }


    get bgStyle(): string {
        return hslColorFromName(this.initial);
    }
    get initial(): string {
        return initialsHelper(this.item.name);
    }

}
